<template>
  <div class="alarm-clock">
    <van-nav-bar title="闹钟设置" :fixed="true" style="margin-bottom:15px;" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <!-- <p class="disturb-title">产品可能会加提示文案</p> -->
    <div v-if="timeList.length>0" class="disturb-content">
      <div v-for="(item,index) in timeList" :key="index" class="disturb-option">
        <div class="option-top"  @click="addOption(item,index)">
          <p>{{item.title}}</p>
          <img class="option-img" src="@/assets/images/disturb-update.png" background-size="cover"/>
        </div>
        <div class="option-bottom">
          <div class="switch-box">
            <p class="b-date">{{item.times}}</p>
            <van-switch class="switch-flex" :disabled="false" v-model="item.status" @change="onChange($event,item,index)"  size="20px" />
          </div>
          <p class="b-week">{{item.days}}</p>
        </div>
      </div>
    </div>
    <div v-else class="address-content">
      <img class="address-img" src="@/assets/images/address_list.png" background-size="cover" />
      <p class="address-txt">设备暂未设置闹钟</p>
    </div>
    <div class="btn-box">
      <van-button round type="info" @click="addOption(false)">添加闹钟</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      timeList:[],//免打扰时段
      ringMode:'',
    }
  },
  created(){
    this.getAlarmClockInfo()
  },
  methods: {
    /**
      * 返回上一级
      */
      backPage() {
          this.$router.back(-1);
      },
    onChange(e,val,ind) {
      // 需要手动对 checked 状态进行更新
      let arr = {
          title:val.title,
          times:val.times,
          days:val.days,
          status:e?1:0
        };
      let data = {
        ver:1,
        method:'sendAlarmClock',
        type:'update',
        instructionId:this.$intfilter.instructFilter('闹钟设置'),
        index:ind,
        paramArr:JSON.stringify(arr)
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.$toast({
              message: "状态修改成功",
              icon: "success",
              duration: 1000
            });
            this.getAlarmClockInfo()
          } else {
            this.$toast({
              message: res.msg,
              duration: 2000,
              icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
    /**
     *获取闹钟列表
     */
    getAlarmClockInfo(){
      let data = {
        ver:1,
        method:'getAlarmClockInfo',
        instructionId:this.$intfilter.instructFilter('闹钟设置')
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            let obj = {
              "0,0":'铃声',
              "0,1":'铃声加震动',
              "1,1":'震动'
            }
            res.data.list.forEach((item,index) => {
              res.data.list[index].status = item.status==1?true:false
            });
            this.timeList = res.data.list
            this.ringMode = obj[res.data.ringMode]
          } else {
            this.$toast({
                message: res.msg,
                duration: 2000,
                icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
    /**
     * 添加闹钟
     */
    addOption(data,index){
      if(data){
        data.index = index
        data.bool = true
        data.ringMode = this.ringMode
        data = JSON.stringify(data)
      }else{
        if(this.timeList.length>=10){
          this.$toast({
              message: '最多只能设置10个闹钟',
              duration: 2000,
              icon: 'none',
          });
          return
        }
        data = {
          bool:false,
          ringMode:this.ringMode
        }
        data = JSON.stringify(data)
      }
      this.$router.push({ name: 'alarmCheckDate' , query: { 'data': data } });
    },
  },
}
</script>

<style scoped>
.alarm-clock{
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 100px 40px 0;
}
.disturb-title{
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin: 30px 0;
}
.address-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 300px;
  font-size: 28px;
  font-weight: 400;
  color: #999999;
}
.address-img{
  width: 426px;
  height: 230px;
}
.address-option{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 180px;
}
.disturb-content{
  margin-bottom: 180px;
}
.address-txt{
  margin-top: 50px;
}
.disturb-option{
  padding: 32px;
  background: #fff;
  border-radius: 20px;
  margin-top: 25px;
}
.disturb-option .option-img{
  width: 30px;
  height: 30px;
}
.disturb-option .option-top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 23px;
}
.disturb-option .option-top>p{
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #111111;
}
.disturb-option .option-bottom{
  display: flex;
  flex-direction: column;
  margin-top: 30px;
}
.disturb-option .option-bottom .switch-box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.disturb-option .option-bottom .b-date{
  font-size: 40px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #111111;
  margin-bottom: 16px;
}
.disturb-option .option-bottom .b-week{
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding-bottom: 70px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
</style>
<style>
.alarm-clock .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background: #01ADA9;
  color: #fff;
  border: 2px solid #01ADA9; 
}
.alarm-clock .switch-flex{
  display: flex;
  align-items: center;
}
.alarm-clock .van-switch--on{
  background-color: #02ADA9 !important;
}
</style>
